// apps/web/src/hooks/useAnalyticsDecidePatchThisWeek.ts
//
// P8a Decide tab — top-10 critical vulnerabilities last 7 days.
// Backed by GET /api/stories/analytics/decide/patch-this-week.

import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface DecideVulnerability {
  cveId: string
  cvssScore: number | null
  criticalReason: 'kev' | 'exploited' | 'high'
  affectedVendors: string[]
}

export interface DecidePatchThisWeekBreakdown {
  kev: number
  exploited: number
  high: number
}

export interface DecidePatchThisWeekResponse {
  criticalCount: number
  // Aggregate breakdown over the full event-date window — sums to
  // criticalCount. Distinct from the visible 10 list rows below. P8a
  // walkthrough fix: `breakdown` is now read straight from the headline
  // aggregate, not derived from the visible rows.
  breakdown: DecidePatchThisWeekBreakdown
  vulnerabilities: DecideVulnerability[]
}

export function useAnalyticsDecidePatchThisWeek() {
  return useQuery<DecidePatchThisWeekResponse>({
    queryKey: ['analytics', 'decide', 'patch-this-week'],
    queryFn: () =>
      api.get<DecidePatchThisWeekResponse>(
        '/stories/analytics/decide/patch-this-week',
      ),
    staleTime: 5 * 60 * 1000,
  })
}
